<script setup lang="ts">
defineExpose({
  name: "CalendarIcon",
});
</script>

<template>
  <svg
    class="CalendarIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_476_5"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" />
    </mask>
    <g mask="url(#mask0_476_5)">
      <path
        d="M3.5 21.5V4.5H6.7V2.375H8.225V4.5H15.8V2.375H17.3V4.5H20.5V21.5H3.5ZM5 20H19V10.3H5V20ZM5 8.8H19V6H5V8.8Z"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.CalendarIcon {
  width: 100%;
  height: auto;
  fill: currentcolor;
}
</style>
